import { ComponentProps, forwardRef } from "react";
import { cn } from "@/lib/utils";
import * as Tabs from "@radix-ui/react-tabs";
import { courseTabsClasses } from "@/classes/courseTabsClasses";

const CourseTabsNav = (props: ComponentProps<"div">) => (
  <div
    {...props}
    style={{ rowGap: 50 - 34 }}
    className={cn(
      courseTabsClasses.nav,
      "bg-paper z-1 my-auto box-border flex h-full min-w-0 flex-col rounded px-5 py-7.5",
      props.className,
    )}
  />
);

interface CourseTabListProps extends Tabs.TabsListProps {
  variant?: "orderedList" | "buttonList";
}

const CourseTabList = forwardRef<HTMLDivElement, CourseTabListProps>(
  ({ variant, ...props }, ref) => (
    <Tabs.List
      {...props}
      ref={ref}
      className={cn(
        courseTabsClasses.tabList,
        "scrollbar-thin flex min-h-0 min-w-0 flex-1 flex-col overflow-y-auto px-2.5 py-0",
        variant === "orderedList" && "gap-y-2.75",
        variant === "buttonList" && "gap-y-10 pt-8.5",
        props.className,
      )}
    />
  ),
);

export { CourseTabsNav, CourseTabList };
